/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Tab_UploadInputs */

const cs_chat_attach_tab_upload = /** @type {(inputs: Chat_Attach_Tab_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nahrát soubor`)
};

const en_chat_attach_tab_upload = /** @type {(inputs: Chat_Attach_Tab_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload file`)
};

/**
* | output |
* | --- |
* | "Upload file" |
*
* @param {Chat_Attach_Tab_UploadInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_tab_upload = /** @type {((inputs?: Chat_Attach_Tab_UploadInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Tab_UploadInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_tab_upload(inputs)
	return cs_chat_attach_tab_upload(inputs)
});